import { Link } from "react-router-dom";
import { Header } from "../components/layout/Header";
import { Footer } from "../components/layout/Footer";

export default function ComingSoon() {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1 flex items-center justify-center px-6 py-32">
        <div className="text-center max-w-md">
          <p className="eyebrow">Mary Pawpins</p>
          <h1 className="font-serif text-4xl sm:text-5xl text-[#292A26] mt-4">This page has wandered off the path.</h1>
          <p className="mt-4 text-[#575953] leading-relaxed">
            The page you're looking for doesn't exist. Let's get you back to familiar ground.
          </p>
          <Link
            to="/"
            data-testid="back-home-button"
            className="mt-8 inline-flex items-center gap-2 rounded-full bg-[#3F4A38] text-[#F7F4ED] px-6 py-3 text-sm font-semibold hover:bg-[#2F382B] transition-colors"
          >
            Back to the homepage
          </Link>
        </div>
      </main>
      <Footer />
    </div>
  );
}
